import { render, staticRenderFns } from "./ServiceRequestAddressUnit.vue?vue&type=template&id=15447648&scoped=true"
import script from "./ServiceRequestAddressUnit.vue?vue&type=script&lang=js"
export * from "./ServiceRequestAddressUnit.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequestAddressUnit.vue?vue&type=style&index=0&id=15447648&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15447648",
  null
  
)

export default component.exports